import script from "./UiTableTh.vue?vue&type=script&setup=true&lang=js"
export * from "./UiTableTh.vue?vue&type=script&setup=true&lang=js"

import "./UiTableTh.vue?vue&type=style&index=0&id=2d0c9128&lang=scss&scoped=true"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-2d0c9128"]])

export default __exports__